import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

const navCatImages: Record<number, string> = {
  1: "https://readdy.ai/api/search-image?query=Elegant%20white%20leather%20sneaker%20side%20view%20on%20warm%20sand%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-1-v2&orientation=squarish",
  2: "https://readdy.ai/api/search-image?query=Folded%20premium%20beige%20hoodie%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic%20texture%20visible&width=80&height=80&seq=nav-cat-2-v2&orientation=squarish",
  3: "https://readdy.ai/api/search-image?query=Neatly%20folded%20cream%20cotton%20tshirt%20on%20warm%20sand%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-3-v2&orientation=squarish",
  4: "https://readdy.ai/api/search-image?query=Folded%20designer%20olive%20jacket%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-4-v2&orientation=squarish",
  5: "https://readdy.ai/api/search-image?query=Folded%20tailored%20beige%20chinos%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-5-v2&orientation=squarish",
  6: "https://readdy.ai/api/search-image?query=Stylish%20beige%20baseball%20cap%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-6-v2&orientation=squarish",
  7: "https://readdy.ai/api/search-image?query=Matching%20coordinated%20fashion%20set%20folded%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-7-v2&orientation=squarish",
  8: "https://readdy.ai/api/search-image?query=Folded%20premium%20cotton%20underwear%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-8-v2&orientation=squarish",
  9: "https://readdy.ai/api/search-image?query=Sports%20basketball%20jersey%20folded%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-9-v2&orientation=squarish",
  10: "https://readdy.ai/api/search-image?query=Luxury%20watch%20bracelet%20accessories%20arrangement%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-10-v2&orientation=squarish",
  11: "https://readdy.ai/api/search-image?query=Elegant%20leather%20tote%20bag%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-11-v2&orientation=squarish",
  12: "https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20buckle%20detail%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-12-v2&orientation=squarish",
  13: "https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20amber%20liquid%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-13-v2&orientation=squarish",
  14: "https://readdy.ai/api/search-image?query=Assorted%20fashion%20accessories%20flatlay%20on%20warm%20cream%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20editorial%20aesthetic&width=80&height=80&seq=nav-cat-14-v2&orientation=squarish"
};

const mobCatImages: Record<number, string> = {
  1: "https://readdy.ai/api/search-image?query=Clean%20white%20sneaker%20on%20warm%20sand%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-1-v2&orientation=squarish",
  2: "https://readdy.ai/api/search-image?query=Folded%20warm%20hoodie%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-2-v2&orientation=squarish",
  3: "https://readdy.ai/api/search-image?query=Folded%20cotton%20tshirt%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-3-v2&orientation=squarish",
  4: "https://readdy.ai/api/search-image?query=Folded%20jacket%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-4-v2&orientation=squarish",
  5: "https://readdy.ai/api/search-image?query=Folded%20tailored%20pants%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-5-v2&orientation=squarish",
  6: "https://readdy.ai/api/search-image?query=Baseball%20cap%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-6-v2&orientation=squarish",
  7: "https://readdy.ai/api/search-image?query=Coordinated%20fashion%20set%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-7-v2&orientation=squarish",
  8: "https://readdy.ai/api/search-image?query=Folded%20cotton%20briefs%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-8-v2&orientation=squarish",
  9: "https://readdy.ai/api/search-image?query=Sports%20jersey%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-9-v2&orientation=squarish",
  10: "https://readdy.ai/api/search-image?query=Fashion%20watch%20and%20bracelet%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-10-v2&orientation=squarish",
  11: "https://readdy.ai/api/search-image?query=Designer%20leather%20bag%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-11-v2&orientation=squarish",
  12: "https://readdy.ai/api/search-image?query=Leather%20belt%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-12-v2&orientation=squarish",
  13: "https://readdy.ai/api/search-image?query=Perfume%20bottle%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-13-v2&orientation=squarish",
  14: "https://readdy.ai/api/search-image?query=Mixed%20accessories%20on%20cream%20background%20minimal%20product%20photo%20soft%20lighting%20editorial%20style&width=88&height=88&seq=mob-cat-14-v2&orientation=squarish"
};

export default function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMobileMenuOpen]);

  const closeAll = () => {
    setIsMobileMenuOpen(false);
    setIsDropdownOpen(false);
  };

  const textClass = isScrolled ? 'text-foreground-800 hover:text-primary-600' : 'text-white/90 hover:text-white';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <Link
            to="/"
            onClick={closeAll}
            className="flex items-center gap-2.5 group flex-shrink-0"
          >
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-tight transition-colors duration-300 ${
              isScrolled ? 'text-foreground-900' : 'text-white'
            }`}>
              Itaobuy Spread
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            <Link
              to="/"
              onClick={closeAll}
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${textClass}`}
            >
              <i className="ri-home-4-line mr-1"></i>
              Home
            </Link>

            <div ref={dropdownRef} className="relative">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className={`flex items-center gap-1.5 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${textClass}`}
              >
                Categorie
                <i className={`ri-arrow-down-s-line transition-transform duration-200 text-base ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isDropdownOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-[560px] bg-background-50 rounded-xl overflow-hidden"
                  style={{
                    boxShadow: '0 4px 24px rgba(0,0,0,0.06), 0 1px 4px rgba(0,0,0,0.04)'
                  }}
                >
                  <div className="p-3">
                    <p className="px-2 mb-2 text-xs font-semibold text-foreground-400 uppercase tracking-wider">Tutte le categorie</p>
                    <div className="grid grid-cols-2 gap-1.5">
                      {categories.map((cat) => (
                        <a
                          key={cat.id}
                          href={cat.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-800 hover:bg-background-100 transition-colors duration-150 group"
                          onClick={() => setIsDropdownOpen(false)}
                        >
                          <div className="w-10 h-10 rounded-lg bg-background-100 overflow-hidden flex-shrink-0 group-hover:ring-2 group-hover:ring-primary-300 transition-all">
                            <img
                              src={navCatImages[cat.id]}
                              alt={cat.nameIt}
                              className="w-full h-full object-cover object-center"
                            />
                          </div>
                          <div>
                            <span className="font-medium whitespace-nowrap">{cat.nameIt}</span>
                            <span className="block text-xs text-foreground-400">{cat.name}</span>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/articolo/guida-completa-itaobuy-spreadsheet"
              onClick={closeAll}
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${textClass}`}
            >
              <i className="ri-book-open-line mr-1"></i>
              Guida
            </Link>

            <Link
              to="/articolo/itaobuy-spreadsheet-sicurezza"
              onClick={closeAll}
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${textClass}`}
            >
              <i className="ri-shield-check-line mr-1"></i>
              Sicurezza
            </Link>

            <Link
              to="/articolo/come-usare-itaobuy-spreadsheet"
              onClick={closeAll}
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${textClass}`}
            >
              <i className="ri-shopping-bag-3-line mr-1"></i>
              Guida Acquisti
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className={`hidden md:inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer ${
                isScrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white text-primary-700 hover:bg-white/90'
              }`}
            >
              Buy It Now
            </a>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors duration-200 cursor-pointer ${
                isScrolled ? 'text-foreground-800 hover:bg-background-100' : 'text-white hover:bg-white/10'
              }`}
            >
              <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-background-50 z-40 overflow-y-auto">
          <div className="px-4 py-4">
            <div className="flex flex-col gap-1 mb-6">
              <Link
                to="/"
                onClick={closeAll}
                className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-base font-semibold text-foreground-900 hover:bg-background-100 transition-colors"
              >
                <i className="ri-home-4-line text-lg text-primary-500"></i>
                Home
              </Link>
              <Link
                to="/articolo/guida-completa-itaobuy-spreadsheet"
                onClick={closeAll}
                className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-base font-medium text-foreground-800 hover:bg-background-100 transition-colors"
              >
                <i className="ri-book-open-line text-lg text-foreground-400"></i>
                Guida Completa
              </Link>
              <Link
                to="/articolo/itaobuy-spreadsheet-sicurezza"
                onClick={closeAll}
                className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-base font-medium text-foreground-800 hover:bg-background-100 transition-colors"
              >
                <i className="ri-shield-check-line text-lg text-foreground-400"></i>
                Sicurezza
              </Link>
              <Link
                to="/articolo/come-usare-itaobuy-spreadsheet"
                onClick={closeAll}
                className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-base font-medium text-foreground-800 hover:bg-background-100 transition-colors"
              >
                <i className="ri-shopping-bag-3-line text-lg text-foreground-400"></i>
                Guida Acquisti
              </Link>
            </div>

            <p className="px-4 mb-3 text-xs font-semibold text-foreground-400 uppercase tracking-wider">
              Categorie Prodotti
            </p>
            <div className="grid grid-cols-1 gap-1 mb-6">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors group"
                  onClick={closeAll}
                >
                  <div className="w-11 h-11 rounded-lg bg-background-100 overflow-hidden flex-shrink-0 group-hover:ring-2 group-hover:ring-primary-300 transition-all">
                    <img
                      src={mobCatImages[cat.id]}
                      alt={cat.nameIt}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="block font-semibold text-foreground-900">{cat.nameIt}</span>
                    <span className="block text-xs text-foreground-400">{cat.name}</span>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
                </a>
              ))}
            </div>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              onClick={closeAll}
              className="flex items-center justify-center gap-2 w-full py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-colors"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}